import React from 'react';
import { object, string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import './index.scss';

const PresenceHeaderTooltipContent = ({ tooltipProps, learnMoreLink }) => (
    <span className="portfolio-presence-tooltip-text">
        <I18n {...tooltipProps}/>
        {learnMoreLink &&
            <a href={learnMoreLink} target={'_blank'} rel="noreferrer">
                <I18n k={'portfolio_showcase_selfview.learn_more'}/>
            </a>
        }
    </span>
);

PresenceHeaderTooltipContent.propTypes = {
    tooltipProps: object,
    learnMoreLink: string
};

export default PresenceHeaderTooltipContent;
